import { render, staticRenderFns } from "./CommunityFaqDetail.vue?vue&type=template&id=54af7c20&scoped=true"
import script from "./CommunityFaqDetail.vue?vue&type=script&lang=js"
export * from "./CommunityFaqDetail.vue?vue&type=script&lang=js"
import style0 from "./CommunityFaqDetail.vue?vue&type=style&index=0&id=54af7c20&prod&scoped=true&lang=css"
import style1 from "./CommunityFaqDetail.vue?vue&type=style&index=1&id=54af7c20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54af7c20",
  null
  
)

export default component.exports